/*==================================================
=           RINGKASAN PERTUMBUHAN
==================================================*/

function getStatusIcon(category) {

    switch (category) {

        case "Berat Badan Ideal":
        case "Normal":
        case "Tinggi Badan Normal":
        case "Berat Badan Normal":
        case "Lingkar Kepala Normal":

            return "🟢";

        case "Berisiko Kelebihan Berat Badan":
        case "Tinggi":

            return "🟡";

        case "Kelebihan Berat Badan":

            return "🟠";

        case "Obesitas":
        case "Sangat Tinggi":

            return "🔴";

        default:

            return "🔵";

    }

}

function createSummary(results) {

    const normalCategories =
        new Set([
            "Normal",
            "Berat Badan Ideal",
            "Tinggi Badan Normal",
            "Berat Badan Normal",
            "Lingkar Kepala Normal"
        ]);

    let abnormal = 0;

    Object.values(results).forEach(
        function (result) {

            if (
                !result ||
                result.error
            ) {
                return;
            }

            if (
                !normalCategories.has(
                    result.category
                )
            ) {
                abnormal++;
            }

        }
    );

    if (abnormal === 0) {

        return {
            icon: "🟢",
            title:
                "Pertumbuhan Sehat",
            message:
                "Secara keseluruhan, pertumbuhan berada dalam rentang sehat WHO."
        };

    }

    if (abnormal === 1) {

        return {
            icon: "🟡",
            title:
                "Pemantauan Pertumbuhan Disarankan",
            message:
                "Satu indikator pertumbuhan berada di luar rentang sehat WHO."
        };

    }

    return {
        icon: "🔴",
        title:
            "Pemeriksaan Lanjutan Disarankan",
        message:
            "Beberapa indikator pertumbuhan berada di luar rentang sehat WHO."
    };

}